<template>
    <div>
        <q-card
            flat
            bordered
            v-for="(appointment, index) in appointments"
            :key="index"
            class="q-mb-sm"
            v-if="appointments.length > 0"
        >
            <q-card-section class="q-pa-sm">
                <q-item>
                    <q-item-section avatar>
                        <q-icon name="account_circle" size="xl" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label style="font-size: 1.5rem">
                            {{ appointment.doctor }}
                        </q-item-label>
                        <q-item-label caption style="font-size: 1rem">
                            {{ appointment.appointmentTime }}
                        </q-item-label>
                        <q-item-label caption style="font-size: 1rem">
                            {{ appointment.appointmentDate }}
                        </q-item-label>
                    </q-item-section>
                </q-item>
            </q-card-section>

            <q-card-section
                class="q-pa-sm"
                style="width: 100%; display: flex; justify-content: end"
            >
                <q-btn
                    label="request cancel"
                    color="negative"
                    class="q-mr-sm"
                    @click="
                        updateAppointmentStatus(
                            appointment.appointmentId,
                            'cancel'
                        )
                    "
                ></q-btn>
                <q-btn
                    label="confirm"
                    color="indigo"
                    @click="
                        updateAppointmentStatus(
                            appointment.appointmentId,
                            'confirm'
                        )
                    "
                ></q-btn>
            </q-card-section>
        </q-card>

        <div v-else style="display: flex; justify-content: center">
            <q-chip outline color="blue" square icon="info">
                You have no appointments
            </q-chip>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import axios from "axios";
import { BASE_PATH, emitter } from "@/main";
export default {
    setup() {
        const appointments = ref([]);

        const updateAppointmentStatus = async (appointmentNo, status) => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                await axios.post(`${BASE_PATH}/update-appt-status`, {
                    appointmentNo,
                    status,
                    demographicNo: patient.Id,
                });
                location.reload();
            } catch (err) {}
        };

        onMounted(async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.get(
                    `${BASE_PATH}/fetch-new-appointment`,
                    {
                        params: { patientId: patient.Id },
                    }
                );
                appointments.value = data.appointments;
            } catch (err) {}

            setTimeout(() => {
                emitter.emit("update-route-name", "NewAppointment");
            }, 100);
        });

        return { appointments, updateAppointmentStatus };
    },
};
</script>
